import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
const CTA_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/8d7551da-c433-4ffc-93f4-d81765071fa5.jpg";
export function ContactCta() {
  return <section aria-labelledby="cta-title" className="bg-paper py-16 md:py-24" data-id="element-37" data-mp="gdjov89597xe">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-38" data-mp="bcw0kucav56v">
        <div className="grid overflow-hidden rounded-[2rem] bg-clay md:grid-cols-2" data-id="element-39" data-mp="3jrxnu50iav0t">
          <div className="flex flex-col justify-center p-10 md:p-14 lg:p-16" data-id="element-40" data-mp="3et2tq6x39k1e">
            <h2 id="cta-title" className="font-display text-4xl font-medium leading-[1.05] tracking-tight text-white md:text-5xl" data-id="element-41" data-mp="3ev77rhopbzfe">
              Votre futur van aménagé est à portée de main.
            </h2>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-white/90" data-id="element-42" data-mp="3otmvrbsfmsko">
              Échangeons sur votre besoin, votre budget et votre usage. Nous vous proposons ensuite une solution adaptée.
            </p>
            <div className="mt-10" data-id="element-43" data-mp="3oe9fu1dqjwy9">
              <Link to="/contact" className="group inline-flex items-center gap-2 rounded-full bg-paper px-7 py-4 text-base font-semibold text-ink transition-colors duration-150 hover:bg-white" data-id="element-44" data-mp="3od7saxfj9hzn">
                Démarrer mon projet
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="68moinr36ae0" />
              </Link>
            </div>
          </div>
          <img src={CTA_IMAGE} alt="Van au toit relevable face à l'océan au coucher du soleil" className="h-72 w-full object-cover md:h-full md:min-h-[460px]" data-id="element-46" data-mp="39otpunm13vjm" />
        </div>
      </div>
    </section>;
}